module.exports = __webpack_public_path__ + "media/images/tip_textarea-4690264d220f35ac7c07140c99ecbd47.png";